import cloneDeep from 'lodash/cloneDeep'

import { IMaterialModificationConflict } from '../../../../models/masterSetPlan'
import { DRAWING_TYPES, PAPER_ELEMENT_TYPE } from '../../../../shared/constants/drawable-types'
import store from '../../../../stores'
import { BulkUpdateOpeningLocationCoordinatesPayload } from '../../../sagas/2D/bulkUpdateOpeningLocationCoordinates'
import { editModificationAction } from '../../../sagas/2D/editModification'
import { updateSelectedPaperId } from '../../../slices/2D'
import { selectSavedMaterialModifications } from '../../../slices/masterSetPlan'
import { setCutoutItem } from '../../../slices/tools'
import { IMUP2DCoordinatesToUpdate } from '../../../types'

function saveMasterPlanSetModifications(): (coordinatesToUpdate: IMUP2DCoordinatesToUpdate) => void {
    return function saveModification(this: paper.Path, coordinatesToUpdate) {
        const materialModificationConflict = this.data.materialModificationConflict as IMaterialModificationConflict

        const updatedMaterialModificationConflict = cloneDeep(materialModificationConflict)

        updatedMaterialModificationConflict.coordinates = coordinatesToUpdate.coordinates

        updatedMaterialModificationConflict.cutouts = coordinatesToUpdate.cutouts ?? []

        store.dispatch(editModificationAction(updatedMaterialModificationConflict))
    }
}

function multiSelectSaveMasterPlanSetModifications(): (payload: BulkUpdateOpeningLocationCoordinatesPayload) => void {
    return function saveModifications(payload) {
        const savedMaterialModifications = selectSavedMaterialModifications(store.getState())

        payload.forEach((entry) => {
            const materialModificationConflict = savedMaterialModifications.find(
                (conflict) => conflict.material_location_id === entry.opening_location_id
            )

            if (!materialModificationConflict) return

            const updatedMaterialModificationConflict = cloneDeep(materialModificationConflict)

            updatedMaterialModificationConflict.coordinates = entry.coordinates
            updatedMaterialModificationConflict.cutouts = entry.cutouts ?? []

            store.dispatch(editModificationAction(updatedMaterialModificationConflict))
        })
    }
}

function selectMasterPlanSetModifications(): () => void {
    return function selectModification(this: paper.Path) {
        store.dispatch(updateSelectedPaperId(this.id))
        if (this.data.shapeType === DRAWING_TYPES.AREA) {
            store.dispatch(setCutoutItem(this.id))
        } else {
            store.dispatch(setCutoutItem(null))
        }
    }
}

function deselectMasterPlanSetModifications(): () => void {
    return function deselectModification(this: paper.Path) {
        store.dispatch(updateSelectedPaperId(null))
    }
}

export default function addSelectFunctionalityToModificationsToEdit(modification: paper.Item): void {
    modification.data.type = PAPER_ELEMENT_TYPE.MODIFICATION_TO_EDIT
    modification.data.onSave = saveMasterPlanSetModifications().bind(modification)
    modification.data.onSelect = selectMasterPlanSetModifications().bind(modification)
    modification.data.onDeselect = deselectMasterPlanSetModifications().bind(modification)
    modification.data.onCutout = saveMasterPlanSetModifications().bind(modification)
    modification.data.isMultiSelectable = true
    modification.data.onMultiSelectSave = multiSelectSaveMasterPlanSetModifications()
}
